import { render, staticRenderFns } from "./Bsr_d.vue?vue&type=template&id=1bd7e67f&scoped=true"
import script from "./Bsr_d.vue?vue&type=script&lang=js"
export * from "./Bsr_d.vue?vue&type=script&lang=js"
import style0 from "./Bsr_d.vue?vue&type=style&index=0&id=1bd7e67f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd7e67f",
  null
  
)

export default component.exports